module.exports = __webpack_public_path__ + "img/sld_star2_delta1_transformer_ta1_ba1.e9d63012.svg";